// MapDisplay.jsx
import React from "react";
import { Map, AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import LabeledMarker from "./CustomMarker";

const MapDisplay = ({ gpsCapture }) => {
  if (!gpsCapture?.startShift) return <p>No GPS data</p>;

  const points = [
    { key: "Start Shift", ...gpsCapture.startShift },
    { key: "Start Break", ...gpsCapture.startBreak },
    { key: "End Break", ...gpsCapture.endBreak },
    { key: "Stop Shift", ...gpsCapture.stopShift },
  ];

  const center = {
    lat: parseFloat(gpsCapture.startShift.latitude),
    lng: parseFloat(gpsCapture.startShift.longitude),
  };

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  return (
    <Map
      style={containerStyle}
      center={center}
      zoom={15}
      disableDefaultUI={true}
      gestureHandling="greedy"
      mapId="a8a858ac94fc4bbf59fa3370"
    >
      {points.map((point) => (
        <LabeledMarker labelText={point.key} point={point} />
      ))}
    </Map>
  );
};

export default MapDisplay;
